import { render, staticRenderFns } from "./areaModal.vue?vue&type=template&id=6f4c1162&scoped=true"
import script from "./areaModal.vue?vue&type=script&lang=js"
export * from "./areaModal.vue?vue&type=script&lang=js"
import style0 from "./areaModal.vue?vue&type=style&index=0&id=6f4c1162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4c1162",
  null
  
)

export default component.exports